import React from 'react';
import '../../css/web/UserMainPg.css';
import {Route, Routes} from "react-router-dom";
import SectionMain from "../../components/web/layoutsuser/SectionMain";
import SideQuickMenu from "../../components/web/layoutsuser/SideQuickMenu";
import UserHeaderRenew from "../../components/web/layoutsuser/UserHeaderRenew";
import UserFooterRenew from "../../components/web/layoutsuser/UserFooterRenew";
import UserOrderPg from "./UserOrderPg";
import UserReviewPg from "./UserReviewPg";
import UserMyPg from "./UserMyPg";
import UserMyOrderPg from "./UserMyOrderPg";
import UserReviewWritePg from "./UserReviewWritePg";
import UserReviewDetailPg from "./UserReviewDetailPg";
import UserCompareShipPg from "./UserCompareShipPg";
import UserCustomInfoPg from "./UserCustomInfoPg";
import UserDepChargePg from "./UserDepChargePg";
import UserNoticePg from "./UserNoticePg";
import UserNoticeDtPg from "./UserNoticeDtPg";
import UserFaqPg from "./UserFaqPg";
import UserFaqDtPg from "./UserFaqDtPg";
import ErrorPathPg from "./ErrorPathPg";
import UserDepChargeHistoryPg from "./UserDepChargeHistoryPg";
import UserUsageGuidePg from "./UserUsageGuidePg";
import UserMailInquiryPg from "./UserMailInquiryPg";
import UserMailSendComplPg from "./UserMailSendComplPg";
import {Helmet} from "react-helmet-async";
import UserSpBoosterPg from "./UserSpBoosterPg";
import UserTermsPg from "./UserTermsPg";
import UserPrivacyPolicyPg from "./UserPrivacyPolicyPg";
import UserPickupRequestPg from "./UserPickupRequestPg";
import UserPickupRequestComplPg from "./UserPickupRequestComplPg";
import UserWechatPg from "./UserWechatPg";

function UserMainPg() {
    return (
        <>

            <Helmet>
                <title>비토리지(Btorage) | 한국상품 전세계로 역구매/배송대행</title>
                <meta name="description" content="[한국에서 전세계로] 한국의 모든 상품을 구매 후 해외배송 대행해드립니다. 실시간채팅, BtoragePay, 국내/해외카드 등 다양한 결제수단과 다양한 해외배송사 비교견적을 통해 편리하고 빠르게 주문해보세요 :)"/>
                <link rel="canonical" href="https://btorage.com/"/>
                <meta property="og:url" content="https://btorage.com/"/>
                <link rel="alternate" hrefLang="ko" href="https://btorage.com/"/>
                <link rel="alternate" hrefLang="x-default" href="https://btorage.com/"/>

                <link rel="icon" type="image/png" sizes="32x32" href="/bt_logo.png"/>
                <link rel="apple-touch-icon" href="/bt_logo.png"/>
                <meta property="og:type" content="website"/>
                <meta property="og:image" content="https://btorage.com/linkBanner.jpg"/>
                <meta property="og:image:width" content="1200"/>
                <meta property="og:image:height" content="630"/>
                <meta property="og:site_name" content="비토리지(Btorage)"/>
                <meta name="twitter:card" content="summary_large_image"/>
                <meta name="twitter:image" content="https://btorage.com/linkBanner.jpg"/>
            </Helmet>

            <div className="user">
                <div className="user-layout">
                    <div className="user-header">
                        <UserHeaderRenew/>
                    </div>
                    <div className="user-body m-b-50 m-t-30">
                        <Routes>
                            <Route exact path="/" element={<SectionMain/>}/> {/*Main*/}
                            <Route path="/UserOrderPg" element={<UserOrderPg/>}/> {/*주문서 작성*/}
                        <Route path="/UserMyPg" element={<UserMyPg/>} /> {/*마이페이지*/}
                        <Route path="/UserMyOrderPg/:ordNum" element={<UserMyOrderPg/>} /> {/*마이 주문서페이지*/}
                        <Route path="/UserReviewPg" element={<UserReviewPg />} /> {/*이용후기*/}
                        <Route path="/UserReviewWritePg" element={<UserReviewWritePg />} /> {/*이용후기 작성페이지*/}
                        <Route path="/UserReviewDetailPg/:seqNum" element={<UserReviewDetailPg/>} /> {/*이용후기 작성완료 페이지*/}
                        <Route path="/UserCompareShipPg" element={<UserCompareShipPg />} /> {/*배송료비교 페이지*/}
                        <Route path="/UserUsageGuidePg" element={<UserUsageGuidePg />} /> {/*이용가이드 페이지*/}
                        <Route path="/UserSpBoosterPg" element={<UserSpBoosterPg />} /> {/*웹쇼핑부스터 페이지*/}
                        <Route path="/UserCustomInfoPg" element={<UserCustomInfoPg />} /> {/*국가별통관정보 페이지*/}
                        <Route path="/UserDepChargePg" element={<UserDepChargePg />} /> {/*국가별통관정보 페이지*/}
                        <Route path="/UserDepChargeHistoryPg" element={<UserDepChargeHistoryPg />} /> {/*국가별통관정보 페이지*/}
                        <Route path="/UserNoticePg" element={<UserNoticePg />} /> {/*공지사항 페이지*/}
                        <Route path="/UserNoticeDtPg/:seqNum" element={<UserNoticeDtPg />} /> {/*공지사항 상세페이지*/}
                        <Route path="/UserFaqPg" element={<UserFaqPg />} /> {/*FAQ 페이지*/}
                        <Route path="/UserFaqDtPg/:seqNum" element={<UserFaqDtPg />} /> {/*FAQ 상세페이지*/}
                        <Route path="/UserMailInquiryPg" element={<UserMailInquiryPg />} /> {/*메일문의 페이지*/}
                        <Route path="/UserMailSendComplPg" element={<UserMailSendComplPg />} /> {/*메일문의 성공페이지*/}
                        <Route path="/UserPickupRequestPg" element={<UserPickupRequestPg />} /> {/*픽업신청 페이지*/}
                        <Route path="/UserPickupRequestComplPg" element={<UserPickupRequestComplPg />} /> {/*픽업신청 성공페이지*/}
                        <Route path="/UserTermsPg" element={<UserTermsPg />} /> {/*이용약관 페이지*/}
                        <Route path="/UserPrivacyPolicyPg" element={<UserPrivacyPolicyPg />} /> {/*개인정보취급방침 페이지*/}
                            <Route path="/UserWechatPg" element={<UserWechatPg/>}/> {/*위챗 친구추가 페이지*/}
                            <Route path="/UserMailSendComplPg" element={<UserMailSendComplPg />} /> {/*메일문의 성공페이지*/}
                        <Route path="*" element={<ErrorPathPg/>}/>
                    </Routes>
                </div>
                <div className="user-quick-menu">
                    <SideQuickMenu/>
                </div>
            </div>
            <div className="user-footer">
                <UserFooterRenew/>
            </div>
        </div>
        </>
    );
}

export default UserMainPg
